import { z } from 'zod';
import { IndicatorType } from '@shared/types';

export const OrderBlocksInputSchema = z.object({
  type: z.literal(IndicatorType.ORDER_BLOCKS),
  gapCandleSizeRatio: z.number(),
  cancelOnMitigation: z.boolean().optional().default(false)
});

export type OrderBlocksInput = z.infer<typeof OrderBlocksInputSchema>;
